import {store} from "../App";
import { getTranslation } from "../utils/translationUtils";
import {getFromHub} from "./networkActions";

export function getTags() {
    getFromHub('excursions/tags', setTags)

}

function setTags(tagsResponse) {
    const tags = {};
    let tagName = "";
    tagsResponse.forEach(tag => {
        tagName = getTranslation(tag.tagName);
        tags[tagName] = tag.imageUrl?.id;
    });

    store.dispatch({
        type: "SET_TAGS",
        tags,
    });
}